import { on } from 'delegated-events';
import { debounce } from './utils/utils';

export default function () {
    const handlesSlider = document.getElementById('mainpage-price-handles');
    if (!handlesSlider) return;

    import('noUiSlider').then(({ default: noUiSlider }) => {
        const inputMin = document.getElementById('mainpage-price1');
        const inputMax = document.getElementById('mainpage-price2');
        const settings = {
            range: {
                'min': [Number(handlesSlider.getAttribute('data-price-min'))],
                'max': [Number(handlesSlider.getAttribute('data-price-max'))]
            },
            start: [Number(inputMin.getAttribute('data-from')) || Number(handlesSlider.getAttribute('data-price-min')), Number(inputMax.getAttribute('data-to')) || Number(handlesSlider.getAttribute('data-price-max'))],
            step: 1
        };

        noUiSlider.create(handlesSlider, settings);

        handlesSlider.noUiSlider.on('update', function (values, handle) {
            if (handle === 0) {
                inputMin.value = Math.round(values[handle]);
            }

            if (handle === 1) {
                inputMax.value = Math.round(values[handle]);
            }
        });

        inputMin.addEventListener('input', debounce(function () {
            handlesSlider.noUiSlider.set([inputMin.value, null]);
        }, 1000));

        inputMax.addEventListener('input', debounce(function () {
            handlesSlider.noUiSlider.set([null, inputMax.value]);
        }, 1000));
    });
}